// Doit rester le premier import : réécrit les appels « /api/... » vers le domaine d'API (cf. lib/apiOrigin.js)
import './lib/apiOrigin';
import { initSentry } from './lib/sentry';
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

// Sentry initialisé avant le premier rendu React
initSentry();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);









